module.exports = __webpack_public_path__ + "static/media/Cunning.83b23144.svg";